<template>
    <div>
        <input hidden type="text" class="form-control" id="InvoiceId" v-model="InvoiceId">
        <div class="modal fade" id="InvoiceStatusModal" tabindex="-1" aria-labelledby="InvoiceStatusModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="InvoiceStatusModalLabel" class="font-weight-bold">{{ModalTitle}}{{InvoiceNo}}</h4>
                        <a type="button" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>

                    <div class="modal-body">
                        <div class="p-3">
                            <CRow>
                                <CCol sm="4">
                                    <label class="form-label font-weight-bold">Status</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </CCol>
                                <CCol sm="8">
                                    <CSelect id="Status" class="font-weight-bold" :options="StatusData" :value.sync="Status" />
                                    <label id="errorStatus" class="form-error" style="display: none; color: red;"></label>
                                </CCol>                                    
                            </CRow>
                        </div>
                        <CButton type="button" @click="saveClick()" class="save-button" id="saveButton" color="success" style="float: right;"> Save </CButton>
                        <label style="float: right;">&nbsp;&nbsp;</label>
                        <CButton type="button" color="secondary" style="float: right;" data-bs-dismiss="modal" aria-label="Close"> Close </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import moment from 'moment';
import {globalfunc} from '../../../../shared/GlobalFunction';
import invoiceServices from '../Script/InvoiceServices.js';
import { response } from '../../../../infrastructure/constant/response';
import { sweet_alert } from '../../../../infrastructure/constant/variable';

export default {
    name: 'InvoiceStatusForm',
    components: {
    },
    props: ['reload'],
    data: function () {
        return {
            ModalTitle : '',

            InvoiceId : '',
            InvoiceNo : '',
            Status : '',
            StatusData : [],
        }
    },
    methods: {
        async statusClick(invoiceData){
            this.ModalTitle = 'Edit Status Invoice: ';
            this.InvoiceId = invoiceData.invoice_id;
            this.InvoiceNo = invoiceData.invoice_number;
            
            this.StatusData = await globalfunc.globalDropdown('ddl_status_invoice');
            this.Status = invoiceData.status;
            
            window.$('#InvoiceStatusModal').modal('show');
        },
        async saveClick(){
            var data = await invoiceServices.getDetailInvoice(this.InvoiceId);

            var deliveryOrderId = null;
            if (data.invoice_type == "1") {
                var deliveryOrderData = await invoiceServices.deliveryOrderArrayToString(data.transaction_invoice_delivery_order);
                deliveryOrderId = deliveryOrderData.delivery_order_id
            }
            
            var transactionInvoiceDetail = this.$globalfunc.objectToArrayConverter(data.transaction_invoice_detail, 'Transaction-Invoice-InvoiceItemDetail');

            //Status Delete Invoice_Number null
            var status = this.Status;
            var InvoiceNumber = data.invoice_number;
            var TaxInvoiceNumber = data.tax_invoice;
            if(status == "Delete") {
                InvoiceNumber = null;
                TaxInvoiceNumber = null;
            }

            const invoiceData = {
                invoice_number: InvoiceNumber,
                invoice_type: data.invoice_type,
                invoice_date: moment(data.invoice_date).format("YYYY-MM-DD"),
                due_date: moment(data.due_date).format("YYYY-MM-DD"),
                status: this.Status,
                purchase_order_id: data.purchase_order_id,
                delivery_order_id: deliveryOrderId,
                customer_id: data.customer_id,
                tax_invoice: TaxInvoiceNumber,
                tax_percentage: data.tax_percentage,
                tax_invoice_deposit: data.tax_invoice_deposit,
                total: data.total,
                total_deposit: data.total_deposit,
                notes: data.notes,
                transaction_invoice_detail: transactionInvoiceDetail
            };

            const variables = {
                id : parseInt(this.InvoiceId),
                data : invoiceData
            };
            
            this.$swal(sweet_alert.update_status).then((result) => {
                if (result.isConfirmed == true) {
                        invoiceServices.editQuery(variables).then(res => {
                        window.$('#InvoiceStatusModal').modal('hide');
                        this.$swal("Info", response.successUpdate, "success");
                        this.$props.reload();
                    }).catch(error => {
                        var errorMessage = globalfunc.errorExtractor(error)
                        this.$swal("Error", errorMessage, "error");
                    })
                }
            });
        },
    }
}
</script>

<style scoped>
.modal-xl-custom {
    max-width: 1500px;
}
</style>